/* eslint-disable */
import React, { useState, useEffect } from 'react';
import { Layout, Table, InputNumber, Button, message, Tag } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import SiderComponent from '../components/SiderComponent';
import HeaderComponent from '../components/HeaderComponent';
import greenfeeDealsApi from '../api/greenfeeDeals';

const { Content } = Layout;

const PKG_COLORS = {
  basic: '#888',
  pro: '#096dd9',
  premium: '#531dab',
  enterprise: '#d46b08',
};

function PackageAdmin(props) {
  const [packages, setPackages] = useState([]);
  const [edits, setEdits] = useState({});
  const [saving, setSaving] = useState({});

  const sessionBnd = localStorage.getItem('sessionBnd');
  const headers = { headers: { Authorization: `Bearer ${sessionBnd}` } };

  useEffect(() => {
    greenfeeDealsApi.get('/packages').then((res) => {
      setPackages(res.data.data.data || []);
    });
  }, []);

  const setField = (id, field, value) => {
    setEdits((prev) => ({
      ...prev,
      [id]: { ...prev[id], [field]: value },
    }));
  };

  const save = async (pkg) => {
    const changes = edits[pkg._id];
    if (!changes || Object.keys(changes).length === 0) return;
    setSaving((s) => ({ ...s, [pkg._id]: true }));
    try {
      const res = await greenfeeDealsApi.patch(`/packages/${pkg._id}`, changes, headers);
      setPackages((prev) =>
        prev.map((p) => (p._id === pkg._id ? res.data.data.data : p))
      );
      setEdits((prev) => ({ ...prev, [pkg._id]: {} }));
      message.success(`${pkg.name} gespeichert`);
    } catch (err) {
      message.error(err.response?.data?.message || 'Fehler');
    } finally {
      setSaving((s) => ({ ...s, [pkg._id]: false }));
    }
  };

  const columns = [
    {
      title: 'Paket',
      dataIndex: 'name',
      key: 'name',
      width: '12%',
      render: (name, pkg) => (
        <Tag
          style={{
            color: PKG_COLORS[pkg.key] || '#888',
            borderColor: PKG_COLORS[pkg.key] || '#888',
            fontWeight: 700,
            fontSize: 13,
          }}
        >
          {name}
        </Tag>
      ),
    },
    {
      title: 'Beschreibung',
      dataIndex: 'description',
      key: 'description',
      width: '28%',
      render: (desc) => <span style={{ fontSize: 13, color: '#555' }}>{desc}</span>,
    },
    {
      title: 'Preis (€ / Monat)',
      key: 'price',
      width: '14%',
      render: (pkg) => (
        <InputNumber
          min={0}
          max={9999}
          value={edits[pkg._id]?.price ?? pkg.price}
          onChange={(v) => setField(pkg._id, 'price', v)}
          addonAfter="€"
          style={{ width: '100%' }}
          disabled={pkg.key === 'enterprise'}
        />
      ),
    },
    {
      title: 'Top-Platzierungen',
      key: 'featuredDealsLimit',
      width: '14%',
      render: (pkg) => (
        <InputNumber
          min={0}
          max={20}
          value={edits[pkg._id]?.featuredDealsLimit ?? pkg.featuredDealsLimit}
          onChange={(v) => setField(pkg._id, 'featuredDealsLimit', v)}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Push-Benachrichtigungen',
      key: 'pushNotificationsLimit',
      width: '14%',
      render: (pkg) => (
        <InputNumber
          min={0}
          max={100}
          value={edits[pkg._id]?.pushNotificationsLimit ?? pkg.pushNotificationsLimit}
          onChange={(v) => setField(pkg._id, 'pushNotificationsLimit', v)}
          style={{ width: '100%' }}
        />
      ),
    },
    {
      title: 'Featured-Dauer (Tage, Pro)',
      key: 'featuredDurationDays',
      width: '14%',
      render: (pkg) => (
        <InputNumber
          min={1}
          max={365}
          value={edits[pkg._id]?.featuredDurationDays ?? pkg.featuredDurationDays}
          onChange={(v) => setField(pkg._id, 'featuredDurationDays', v)}
          style={{ width: '100%' }}
          disabled={pkg.key !== 'pro'}
        />
      ),
    },
    {
      title: '',
      key: 'save',
      width: '8%',
      render: (pkg) => {
        const hasChanges = edits[pkg._id] && Object.keys(edits[pkg._id]).length > 0;
        return (
          <Button
            type="primary"
            icon={<SaveOutlined />}
            size="small"
            disabled={!hasChanges}
            loading={saving[pkg._id]}
            onClick={() => save(pkg)}
            style={{ background: hasChanges ? '#2e7d32' : undefined, borderColor: hasChanges ? '#2e7d32' : undefined }}
          >
            Speichern
          </Button>
        );
      },
    },
  ];

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <SiderComponent props={props} />
      <Layout>
        <HeaderComponent />
        <Content style={{ backgroundColor: '#F5F5F5', padding: '32px 40px' }}>
          <div
            style={{
              backgroundColor: 'white',
              borderRadius: 8,
              padding: '24px 32px',
              boxShadow: '0 1px 2px rgba(0,0,0,0.03)',
            }}
          >
            <h2 className="Form-heading" style={{ marginBottom: 6 }}>Pakete verwalten</h2>
            <p style={{ fontSize: 14, color: '#888', marginBottom: 24 }}>
              Lege Preise und Limits für die vier festen Paket-Stufen fest. Clubs können Pakete direkt in ihrer Top-Deals-Übersicht aktivieren.
            </p>
            <Table
              rowKey="_id"
              columns={columns}
              dataSource={packages}
              pagination={false}
              className="top-deals-table"
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
}

export default PackageAdmin;
